import React from 'react';
import { motion } from 'framer-motion';
import { Globe, Code2, Sparkles, CheckCircle2 } from 'lucide-react';
export const OfferCards = () => {
  return <section className="w-full bg-sand-200 py-24 px-6 relative" data-id="element-59">
      <div className="max-w-6xl mx-auto" data-id="element-60">
        <div className="text-center mb-16" data-id="element-61">
          <h2 className="font-display text-4xl md:text-5xl text-slate-800 mb-4" data-id="element-62">
            Choose Your Slice
          </h2>
          <p className="text-lg text-slate-600" data-id="element-63">
            Two simple ways to make this domain yours.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-64">
          {/* Option 1: Just Domain */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} whileHover={{
          y: -8
        }} className="bg-white rounded-3xl p-8 md:p-10 shadow-xl shadow-sand-300/50 border-2 border-transparent hover:border-coral-200 transition-colors flex flex-col h-full" data-id="element-65">
            <div className="w-16 h-16 bg-citrus-100 text-citrus-500 rounded-2xl flex items-center justify-center mb-6" data-id="element-66">
              <Globe size={32} data-id="element-67" />
            </div>
            <h3 className="font-display text-3xl text-slate-800 mb-2" data-id="element-68">
              Just the Domain
            </h3>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-69">
              Purchase the .com outright and transfer it to your preferred
              registrar. Perfect if you already have a team ready to build.
            </p>

            <ul className="space-y-4 mb-10" data-id="element-70">
              <li className="flex items-start text-slate-700" data-id="element-71">
                <CheckCircle2 className="text-palm-500 mr-3 shrink-0 mt-0.5" size={20} data-id="element-72" />
                <span data-id="element-73">Full ownership of juicyonthebeach.com</span>
              </li>
              <li className="flex items-start text-slate-700" data-id="element-74">
                <CheckCircle2 className="text-palm-500 mr-3 shrink-0 mt-0.5" size={20} data-id="element-75" />
                <span data-id="element-76">Smooth transfer process</span>
              </li>
            </ul>

            <div className="mt-auto pt-6 border-t border-slate-100" data-id="element-77">
              <div className="text-2xl font-bold text-slate-800 mb-6" data-id="element-78">
                Contact for pricing
              </div>
              <a href="#contact" className="block w-full py-4 px-6 bg-slate-800 hover:bg-slate-900 text-white text-center rounded-xl font-semibold transition-colors" data-id="element-79">
                Inquire Now
              </a>
            </div>
          </motion.div>

          {/* Option 2: Domain + Web Page */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} whileHover={{
          y: -8
        }} className="bg-coral-600 rounded-3xl p-8 md:p-10 shadow-2xl shadow-coral-600/30 relative flex flex-col h-full overflow-hidden" data-id="element-80">
            {/* Best Value Badge */}
            <div className="absolute top-6 right-6 bg-citrus-400 text-slate-900 text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wider flex items-center gap-1 shadow-sm" data-id="element-81">
              <Sparkles size={14} data-id="element-82" />
              Best Value
            </div>

            {/* Decorative background shape */}
            <div className="absolute -bottom-20 -right-20 w-64 h-64 bg-coral-500 rounded-full blur-3xl opacity-50 pointer-events-none" data-id="element-83"></div>

            <div className="w-16 h-16 bg-white/20 text-white rounded-2xl flex items-center justify-center mb-6 backdrop-blur-sm relative z-10" data-id="element-84">
              <Code2 size={32} data-id="element-85" />
            </div>
            <h3 className="font-display text-3xl text-white mb-2 relative z-10" data-id="element-86">
              Domain + Web Page
            </h3>
            <p className="text-coral-100 mb-8 flex-grow relative z-10" data-id="element-87">
              Get the domain PLUS a custom-built, professional single-page
              website designed and developed by José.
            </p>

            <ul className="space-y-4 mb-10 relative z-10" data-id="element-88">
              <li className="flex items-start text-white" data-id="element-89">
                <CheckCircle2 className="text-citrus-400 mr-3 shrink-0 mt-0.5" size={20} data-id="element-90" />
                <span data-id="element-91">Full ownership of juicyonthebeach.com</span>
              </li>
              <li className="flex items-start text-white" data-id="element-92">
                <CheckCircle2 className="text-citrus-400 mr-3 shrink-0 mt-0.5" size={20} data-id="element-93" />
                <span data-id="element-94">Custom single-page website design</span>
              </li>
              <li className="flex items-start text-white" data-id="element-95">
                <CheckCircle2 className="text-citrus-400 mr-3 shrink-0 mt-0.5" size={20} data-id="element-96" />
                <span data-id="element-97">Mobile-responsive & fast</span>
              </li>
            </ul>

            <div className="mt-auto pt-6 border-t border-coral-500 relative z-10" data-id="element-98">
              <div className="flex items-baseline gap-2 mb-6" data-id="element-99">
                <span className="text-4xl font-display text-white" data-id="element-100">$350</span>
                <span className="text-coral-100" data-id="element-101">total cost</span>
              </div>
              <a href="#contact" className="block w-full py-4 px-6 bg-white hover:bg-sand-100 text-coral-600 text-center rounded-xl font-bold transition-colors shadow-lg" data-id="element-102">
                Get the Bundle
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};